














































import Vue from "vue";
import FinishForm from "@/components/FinishForm.vue";

export default Vue.extend({
    name: "Home",
    components: {
      FinishForm
    },

    data() {
        return {
            logout: false,
            comment: ""
        };
    },

    computed: {
        exams(): {} {
            const examsList = this.$store.state.general.examsList;
            examsList.programming.allowed = true;
            // examsList.english.allowed = !examsList.programming?.started && !examsList.typeSpeed?.started;
            // examsList.typeSpeed.allowed = !examsList.programming?.started && !examsList.english?.started;

            return examsList;
        },
        programmingLoading(): boolean {
            return this.$store.state.programming.loading;
        },
        englishLoading(): boolean {
            return this.$store.state.english.loading;
        },
        typingLoading(): boolean {
            return this.$store.state.typing.loading;
        },
        examFinished(): boolean {
            const examFinished = this.$store.state.general.examFinished;
            if (examFinished) {
                this.logout = true;
            }
            return examFinished;
        }
    },

    watch: {
        logout() {
            this.$store.dispatch("general/logout");
        }
    },
    methods: {
        sendComment() {
            console.log(this.comment);
        }
    }
});
